import React from "react"
import GridOrg from "@onestore/hel/dist/components/organisms/GridOrg"
import useGenericPageUrlQuery from "@gatsby-plugin-generic-page/hooks/useGenericPageUrlQuery"
import NestedGenericPagesList from "@gatsby-plugin-generic-page/sections/SitemapSection/components/NestedGenericPagesList"

export type NestedGenericPageType = {
  flatData: {
    url: string
    metaTitle: string
  }
  children: {
    [key: string]: NestedGenericPageType
  }
}

export type NestedGenericPagesType = {
  [key: string]: NestedGenericPageType
}

const GenericPageSitemap = () => {
  const genericPageUrls = useGenericPageUrlQuery()

  const nestedGenericPages: NestedGenericPagesType = genericPageUrls.reduce(
    (result, page) => {
      const pathParts = page.flatData.url.split("/").filter(Boolean)

      let currentLevel = result

      pathParts.forEach((part) => {
        if (!currentLevel[part]) {
          currentLevel[part] = {
            flatData: page.flatData,
            children: {},
          }
        }
        currentLevel = currentLevel[part].children
      })

      return result
    },
    {}
  )

  const countNestedGenericPages = (pages: NestedGenericPagesType) => {
    return Object.keys(pages).reduce(
      (result, key) =>
        result +
        (pages[key].flatData ? 1 : 0) +
        countNestedGenericPages(pages[key].children),
      0
    )
  }

  const nestedGenericPagesLength = countNestedGenericPages(nestedGenericPages)

  return (
    <GridOrg
      columns={{ small: 1, medium: 2, large: 3 }}
      rows={{
        small: nestedGenericPagesLength,
        medium: Math.ceil(nestedGenericPagesLength / 2),
        large: Math.ceil(nestedGenericPagesLength / 3),
      }}
      autoFlow={{ small: "row", medium: "column", large: "column" }}
      gutterSpace={{
        small: 1,
        medium: { x: 3, y: 1 },
        large: { x: 4.5, y: 1 },
      }}
    >
      <NestedGenericPagesList pages={nestedGenericPages} leftSpace={0} />
    </GridOrg>
  )
}

export default GenericPageSitemap
